module.exports = __webpack_public_path__ + "static/media/Madison.53b0bedc.jpg";